/* PLUXOS: wording + scent pills in the Appstle subscription portal (/apps/subscriptions).
   Loaded only on that page (layout/theme.liquid). Appstle renders the portal with React and
   re-renders often, so this watches the page and re-applies whenever it changes.

   IMPORTANT: never change the text nodes or children that Appstle (React) renders. Replacing them
   crashes React on its next update ("removeChild ... not a child") and blanks the portal.
   So: our wording goes into data-plx-text / data-plx-em attributes and CSS shows it (see
   assets/pluxos-portal.css, [data-plx-text]); Appstle's own elements are hidden with data-plx-hide;
   anything new we add (offer how-to, scent pills) is our own element placed next to Appstle's.

   1) Rewards pill: "Get 20% off · Unlocks with your Dec 19 order" (reads like a coupon link)
      → "REWARDS PROGRESS · Stay subscribed: 20% off every order from Dec 19 onward".
   2) Cancel pop-up offer screens: title, message and main button per reason (swap / discount / skip / pause).
   3) Scent dropdowns → product-page scent pills.
*/
(function () {
  function setText(el, text, em) {
    if (!el) return;
    if (el.getAttribute('data-plx-text') !== text) el.setAttribute('data-plx-text', text);
    if ((el.getAttribute('data-plx-em') || '') !== (em || '')) {
      if (em) el.setAttribute('data-plx-em', em); else el.removeAttribute('data-plx-em');
    }
  }

  /* 1) Rewards pill */
  var RE_DATE = /with your (.+?) order/i;
  function rewriteLadder() {
    var heads = document.querySelectorAll('.as-reward-ladder__headline');
    for (var i = 0; i < heads.length; i++) {
      var head = heads[i];
      var pill = head.closest('.as-reward-ladder__pill') || head.parentNode;
      var sub = pill.querySelector('.as-reward-ladder__subline');
      var rawHead = (head.textContent || '').trim();          // Appstle's text, never changed by us
      var rawSub = sub ? (sub.textContent || '').trim() : '';
      var reward = rawHead.replace(/^get\s+/i, '').replace(/^free product:\s*/i, 'Free ').replace(/\s*\|.*$/, '');
      var m = rawSub.match(RE_DATE);
      var date = m ? m[1] : '';
      var line, em = '';
      var pct = reward.match(/\d+\s*%\s*off/i);
      // Store reward setup (Appstle rewards + "Month 3 onward" on the product page): 20% off starts on the 3rd order
      var ORDER_NO = { '20': '3rd' };
      var nth = pct ? ORDER_NO[(pct[0].match(/\d+/) || [])[0]] : '';
      if (pct && date && nth) { line = 'Stay subscribed until your ' + nth + ' order (' + date.replace(/ /g, '\u00a0') + ') to get ' + rewardName(pct[0].replace(/\s+/g, ' ')).toUpperCase() + ' every order '; em = 'onward!'; }
      else if (pct && date) { line = 'Stay subscribed: ' + pct[0] + ' every order from ' + date + ' '; em = 'onward!'; }
      else if (date) { line = 'Stay subscribed: ' + reward + ' with your ' + date + ' order'; }
      else { line = rawSub || reward; }
      setText(head, 'Rewards progress');
      if (sub) setText(sub, line, em);
      var label = 'Rewards progress. ' + line + em + '. Show all rewards';
      if (pill.getAttribute('aria-label') !== label) pill.setAttribute('aria-label', label);
    }
  }

  /* 1b) Rewards pop-up (opens from the pill): title "Upcoming rewards"; the reward you have now says
         "Current" (was "Active"); the next one says "Next reward on Dec 19" (was just "Dec 19"). */
  function rewriteLadderModal() {
    var modals = document.querySelectorAll('.as-reward-ladder__modal, .as-reward-ladder__popup'); // pop-up on desktop, bottom sheet on phones
    for (var i = 0; i < modals.length; i++) {
      var m = modals[i];
      setText(m.querySelector('.as-modal-title > span, .as-reward-ladder__popup-title'), 'Upcoming rewards');
      var tiers = m.querySelectorAll('.as-reward-ladder__tier');
      for (var t = 0; t < tiers.length; t++) {
        var cap = tiers[t].querySelector('.as-reward-ladder__tier-caption');
        if (!cap) continue;
        var raw = (cap.textContent || '').trim();
        if (tiers[t].classList.contains('is-unlocked')) setText(cap, 'Current');
        else if (tiers[t].classList.contains('is-next') && raw) setText(cap, 'Next reward on ' + raw);
        else if (raw) setText(cap, 'Reward on ' + raw);
      }
      // Percentages the way the product page shows them (vs the $52 compare-at price): 15% → 28%, 20% → 32%.
      // Uses the price ratio the products card worked out (window.plxPriceRatio); Appstle's own % if unknown.
      var labels = m.querySelectorAll('.as-reward-ladder__tier-label, .as-reward-ladder__stat-value');
      for (var l = 0; l < labels.length; l++) {
        var lt = (labels[l].textContent || '').trim();
        var pm = lt.match(/^get\s+(\d+)\s*%\s*off$/i);
        var gm = lt.match(/^free (?:gift|product)\s*\(?\s*([^|)]+)/i);
        if (pm) {
          var d = parseInt(pm[1], 10);
          var shown = plxPriceRatio ? Math.floor((1 - (1 - d / 100) * plxPriceRatio) * 100 + 1e-6) : d;
          setText(labels[l], shown + '% off');
        } else if (gm) setText(labels[l], 'Free ' + gm[1].trim());
      }
    }
  }
  var plxPriceRatio = 0, plxLinePrices = {}, plxMonthly = true;

  /* 1c) Details page buttons. Appstle's text links become real buttons. We never move Appstle's
         elements: its own link is hidden (data-plx-hide) and our button next to the others clicks it.
         - "Add Products" (top right of the products box) → ADD PRODUCTS button beside SWAP SCENT
           under the first product; "Swap" → SWAP SCENT button (CSS).
         - "Reschedule" (top right of the next order box) → RESCHEDULE button under Order now / Skip order. */
  function proxyButton(id, label, cls, target, parent) {
    var b = parent.querySelector(':scope > [data-plx-proxy="' + id + '"]');
    if (!b) {
      b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-plx-proxy', id);
      b.className = cls;
      b.textContent = label;
      parent.appendChild(b);
    }
    b.onclick = function (e) { e.preventDefault(); var t = target(); if (t) t.click(); };
    return b;
  }
  function enhanceDetails() {
    var addCta = document.querySelector('.as-cp-wrapper .as-product-details .as-add-product-cta');
    var wrap = addCta && addCta.closest('.as-btn-wrapper');
    var swapRow = document.querySelector('.as-cp-wrapper .as-product-details .as-swap-edit-product-cta');
    swapRow = swapRow && swapRow.parentNode;
    if (addCta && wrap && swapRow) {
      if (!wrap.hasAttribute('data-plx-hide')) wrap.setAttribute('data-plx-hide', '');
      if (!swapRow.hasAttribute('data-plx-actions')) swapRow.setAttribute('data-plx-actions', '');
      proxyButton('add-products', 'Add products', 'plx-btn plx-btn--ghost plx-btn--sm', function () {
        return document.querySelector('.as-cp-wrapper .as-product-details .as-add-product-cta');
      }, swapRow);
    }
    var swaps = document.querySelectorAll('.as-cp-wrapper .as-product-details .as-swap-edit-product-cta');
    for (var i = 0; i < swaps.length; i++) {
      setText(swaps[i], 'Swap scent');
      var row = swaps[i].parentNode;
      if (row && !row.hasAttribute('data-plx-actions')) row.setAttribute('data-plx-actions', '');
    }

    var bill = document.querySelector('.as-cp-wrapper .as-edit-billing');
    var resched = bill && bill.querySelector('.as-edit-billing_cta');
    var btns = bill && bill.querySelector('.as-edit-billing_buttons');
    if (resched && btns) {
      if (!resched.hasAttribute('data-plx-hide')) resched.setAttribute('data-plx-hide', '');
      proxyButton('reschedule', 'Reschedule', 'plx-btn plx-btn--ghost', function () {
        return document.querySelector('.as-cp-wrapper .as-edit-billing .as-edit-billing_cta');
      }, btns);
    }
  }

  /* 2) Cancel pop-up offer screens. Appstle tags the buttons by offer type (as-accept-btn-swap /
        -discount / -skip / -pause); numbers (20%, 1 month) are read from the message set per reason
        in Appstle → Retention Management, so they stay in sync. */
  // Oct 22: on the step that really cancels, tell people how to come back (My account lists cancelled
  // subscriptions with a REACTIVATE SUBSCRIPTION button; the portal list has one too, section 13)
  // Oct 22 19:45 (owner): shorter + easier to see: a black tag, then one line on how
  var REACT_HTML = '<span class="plx-react-note__tag">You can reactivate anytime</span>' +
    '<span class="plx-react-note__how">Go to <b>My Account</b> and tap <b>Reactivate subscription</b>.</span>';
  function reactNote() { var d = document.createElement('div'); d.className = 'plx-react-note'; d.innerHTML = REACT_HTML; return d; }
  var OFFERS = {
    swap: function () {
      return {
        title: 'Change your scent',
        accept: 'Swap scent or product',
        html: '<p class="plx-offer__lead">Switch to a new scent or product in three taps:</p>' +
          '<ol class="plx-offer__steps">' +
          '<li><span><b>Tap Swap scent or product</b> below</span></li>' +
          '<li><span><b>Pick a product</b> and choose your scent</span></li>' +
          '<li><span><b>Tap Confirm swap</b> and you\u2019re done</span></li></ol>' +
          '<p class="plx-offer__note">Your next order ships with your new pick. Your subscriber price and rewards stay the same.</p>'
      };
    },
    discount: function (msg) {
      var pct = (msg.match(/(\d+)\s*%/) || [])[1] || '20';
      // Oct 22: the last offer (after the Don't go picture) reads as a friendly last try; its No thanks really cancels
      if (plxDontgoDone) return {
        title: 'One last discount before you go! ' + pct + '% off your next order',
        accept: 'Get ' + pct + '% off my next order',
        decline: 'No thanks, cancel my subscription',
        pct: +pct,
        html: '<p class="plx-offer__lead">We just wanted to offer you one last discount: stay subscribed and we’ll take <b>' + pct + '% off your next order</b>.</p>' +
          '<div class="plx-offer__deal" data-plx-deal hidden></div>' +
          '<p class="plx-offer__note">It’s added automatically, nothing to enter. Your rewards keep counting and you can still skip or cancel anytime.</p>' +
          '<div class="plx-react-note">' + REACT_HTML + '</div>'
      };
      return {
        title: pct + '% off your next order',
        accept: 'Get ' + pct + '% off my next order',
        html: '<p class="plx-offer__lead">Stay subscribed and we’ll take <b>' + pct + '% off your next order</b>.</p>' +
          '<p class="plx-offer__note">It’s added automatically, nothing to enter. Your rewards keep counting and you can still skip or cancel anytime.</p>'
      };
    },
    skip: function (msg) {
      var n = (msg.match(/(\d+)\s*order/i) || [])[1] || '1';
      var orders = n === '1' ? 'your next order' : 'your next ' + n + ' orders';
      return {
        title: 'Skip a month instead',
        accept: n === '1' ? 'Skip my next order' : 'Skip ' + n + ' orders',
        html: '<p class="plx-offer__lead">Use up what you have. We’ll <b>skip ' + orders + '</b> and pick back up after.</p>' +
          '<p class="plx-offer__note">Nothing ships and you aren’t charged for skipped orders. Same price and rewards when it restarts.</p>'
      };
    },
    pause: function (msg) {
      var m = msg.match(/for\s+(\d+)\s+([a-z]+)/i);
      var len = m ? (m[1] + ' ' + (m[1] === '1' ? m[2].replace(/s$/i, '') : m[2])) : '1 month';
      return {
        title: 'Take a break instead',
        accept: 'Pause for ' + len,
        html: '<p class="plx-offer__lead">Pause your subscription for <b>' + len + '</b>. Nothing ships and you won’t be charged.</p>' +
          '<p class="plx-offer__note">It restarts on its own after the break, or resume anytime from Manage subscription.</p>'
      };
    }
  };

  /* Oct 22: the last 20% screen shows what their next order would cost with it: price after the 20%, the
     original (compare-at) price struck through, the total % off, and "You save $x". Worked out from the
     subscription itself (all its lines, add-ons included; shipping not included, as the 20% doesn't touch it),
     with the original prices from #PlxAdCompare. Hidden if anything is missing. */
  var plxDeal = { cid: '', data: null, busy: false };
  function fillDeal(el, pct) {
    if (!el || el.getAttribute('data-plx-filled')) return;
    var cid = contractId();
    if (!cid) return;
    if (plxDeal.cid !== cid || !plxDeal.data) {
      if (plxDeal.busy) return;
      plxDeal.busy = true;
      fetch(apiUrl('subscription-contracts/contract-external/' + cid), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { plxDeal = { cid: cid, data: j, busy: false }; schedule(); })
        .catch(function () { plxDeal.busy = false; });
      return;
    }
    var c = plxDeal.data;
    var lines = c && c.lines ? (c.lines.nodes || (c.lines.edges || []).map(function (e) { return e.node; })) : [];
    var now = 0, orig = 0, already = 0;
    (lines || []).forEach(function (l) {
      if (!l) return;
      var q = l.quantity || 1, cur = Math.round(parseFloat((l.currentPrice || {}).amount || 0) * 100);
      var vid = String(l.variantId || '').split('/').pop();
      var cmp = cmpFor(vid);
      now += cur * q;
      orig += (cmp > cur ? cmp : cur) * q;
      (l.discountAllocations || []).forEach(function (a) { already += Math.round(parseFloat((a.amount || {}).amount || 0) * 100); });
    });
    if (!now || !orig) return;
    var price = Math.max(0, now - already - Math.round(now * pct / 100));
    var off = pctOff(price, orig), save = orig - price;
    var day = c.nextBillingDate ? new Date(c.nextBillingDate) : null;
    el.innerHTML = '<p class="plx-offer__deal-label">Your next order' + (day ? ' · ' + esc(shortD(day)) : '') + '</p>' +
      '<div class="plx-offer__deal-row"><span class="plx-offer__deal-now">' + money(price) + '</span>' +
      (off > 0 ? '<s class="plx-offer__deal-was">' + money(orig) + '</s><span class="plx-offer__deal-tag">' + off + '% off</span>' : '') + '</div>' +
      (save > 0 ? '<p class="plx-offer__deal-save">You save ' + money(save) + ' on this order</p>' : '');
    el.setAttribute('data-plx-filled', '1');
    el.removeAttribute('hidden');
  }

  function rewriteOffers() {
    var modals = document.querySelectorAll('.cancelSubscriptionModal');
    for (var i = 0; i < modals.length; i++) {
      var m = modals[i];
      var accept = m.querySelector('.as-accept-btn');
      var body = m.querySelector('.as-modal-body');
      var mine = body && body.querySelector(':scope > .plx-offer');
      var title = m.querySelector('.as-modal-title > span');
      // the last "No! Don't gooo…" screen is showing: its title wins
      if (m.hasAttribute('data-plx-confirm')) { var tt = m.querySelector('[data-plx-title]') || title; if (tt) setText(tt, 'Before you go'); continue; }
      var type = accept ? (accept.className.match(/as-accept-btn-([a-z]+)/) || [])[1] : null;
      // reason list: its button never cancels straight away now (an offer or the Don't go picture comes first)
      var reasonBtn = m.querySelector('#cancellationReason') ? Array.prototype.filter.call(m.querySelectorAll('button[type="submit"]'), function (b) { return /cancel/i.test(b.textContent || ''); })[0] : null;
      if (reasonBtn) setText(reasonBtn, 'Continue cancelling subscription');
      if (!accept || !OFFERS[type] || !body) {
        // not an offer screen (reason list, final check): undo our changes
        if (mine) mine.remove();
        if (title && title.hasAttribute('data-plx-text')) title.removeAttribute('data-plx-text');
        // e.g. Appstle's "You're all set" screen re-uses the offer's button as Close: give it back its own words
        Array.prototype.forEach.call(m.querySelectorAll('button[data-plx-text]'), function (b) { if (b !== reasonBtn) b.removeAttribute('data-plx-text'); });
        // success screen ("You're all set" + the success message): its only button closes the pop-up → DONE
        if (accept && /^close$/i.test((accept.textContent || '').trim())) setText(accept, 'Done');
        // after the Don't go picture, Appstle's own last step ("Cancel your subscription?", shown when the 20% was
        // already used) cancels on its No thanks button, so it says so
        if (plxDontgoDone) {
          var lastNo = Array.prototype.filter.call(m.querySelectorAll('button'), function (b) { return CONTINUE_CANCEL.test((b.textContent || '').trim()); })[0];
          if (lastNo) setText(lastNo, 'No thanks, cancel my subscription');
          if (lastNo && body && !body.querySelector('.plx-react-note')) body.appendChild(reactNote());
          // Appstle's own line ("You can manage your subscription anytime. If you cancel, your upcoming orders will stop —
          // you can restart whenever you like.") → one short, darker line (owner, Oct 22 19:45)
          if (lastNo && body) {
            var amsg = Array.prototype.filter.call(body.querySelectorAll(':scope > *'), function (e) {
              return !e.classList.contains('plx-react-note') && /upcoming orders|manage your subscription/i.test(e.textContent || '');
            })[0];
            if (amsg) { setText(amsg, 'If you cancel, your upcoming orders stop and you will no longer be charged.'); amsg.setAttribute('data-plx-msg', ''); }
          }
        } else if (body) {
          var oldRn = body.querySelector(':scope > .plx-react-note');
          if (oldRn) oldRn.remove();
          var oldMsg = body.querySelector('[data-plx-msg]');
          if (oldMsg) { oldMsg.removeAttribute('data-plx-msg'); oldMsg.removeAttribute('data-plx-text'); }
        }
        var hidden = body ? body.querySelectorAll('[data-plx-hide]') : [];
        for (var h = 0; h < hidden.length; h++) hidden[h].removeAttribute('data-plx-hide');
        continue;
      }
      var msgEl = body.querySelector(':scope > div:not(.plx-offer)');
      if (!msgEl) continue;
      var copy = OFFERS[type]((msgEl.textContent || '').trim());
      var mkey = type + (copy.decline ? '-last' : '');
      if (!mine || mine.getAttribute('data-type') !== mkey) {
        if (mine) mine.remove();
        mine = document.createElement('div');
        mine.className = 'plx-offer';
        mine.setAttribute('data-type', mkey);
        mine.innerHTML = copy.html;
        body.appendChild(mine);
      }
      if (!msgEl.hasAttribute('data-plx-hide')) msgEl.setAttribute('data-plx-hide', '');
      if (copy.pct) fillDeal(mine.querySelector('[data-plx-deal]'), copy.pct);
      setText(title, copy.title);
      setText(accept, copy.accept);
      var decline = Array.prototype.filter.call(m.querySelectorAll('button'), function (b) { return b !== accept && CONTINUE_CANCEL.test((b.textContent || '').trim()); })[0];
      if (decline) {
        if (copy.decline) setText(decline, copy.decline);
        else if (decline.hasAttribute('data-plx-text')) decline.removeAttribute('data-plx-text');
      }
    }
  }

  /* 3) Scent dropdowns → product-page scent pills (Unscented / Peach / Vanilla), wherever Appstle shows a
        scent <select> (swap picker, add-to-order cards, edit pop-ups). The select stays (hidden) and the
        pills drive it through React's own onChange, so Appstle's logic keeps working. */
  var SCENT_TINT = { unscented: '#F6F4EF', peach: '#FADFD0', vanilla: '#FBF0C9' }; // Oct 21 palette, same as the product pages
  var setSelect = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;

  function scentPills() {
    // drop pills whose select was replaced/removed by Appstle
    var walls = document.querySelectorAll('.plx-scents');
    for (var w = 0; w < walls.length; w++) {
      var p = walls[w].previousElementSibling;
      if (!p || p.tagName !== 'SELECT') walls[w].remove();
    }
    var sels = document.querySelectorAll('.as-cp-wrapper select, .as-cp-modal select');
    for (var i = 0; i < sels.length; i++) buildPills(sels[i]);
  }

  function buildPills(sel) {
    var opts = Array.prototype.slice.call(sel.options);
    if (!opts.length || !opts.every(function (o) { return SCENT_TINT.hasOwnProperty((o.textContent || '').trim().toLowerCase()); })) return;
    var wrap = sel.nextElementSibling && sel.nextElementSibling.classList.contains('plx-scents') ? sel.nextElementSibling : null;
    var sig = opts.map(function (o) { return o.value; }).join('|');
    if (!wrap || wrap.getAttribute('data-sig') !== sig) {
      if (wrap) wrap.remove();
      wrap = document.createElement('div');
      wrap.className = 'plx-scents';
      wrap.setAttribute('role', 'radiogroup');
      wrap.setAttribute('data-sig', sig);
      opts.forEach(function (o) {
        var name = (o.textContent || '').trim();
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'plx-scent';
        b.textContent = name;
        b.setAttribute('role', 'radio');
        b.setAttribute('data-value', o.value);
        b.style.setProperty('--tint', SCENT_TINT[name.toLowerCase()]);
        if (name.toLowerCase() === 'unscented') b.setAttribute('data-white', '');
        b.addEventListener('click', function () {
          var cur = wrap.previousElementSibling && wrap.previousElementSibling.tagName === 'SELECT' ? wrap.previousElementSibling : sel;
          pickScent(cur, o.value);
          syncPills(cur, wrap);
        });
        wrap.appendChild(b);
      });
      sel.parentNode.insertBefore(wrap, sel.nextSibling);
    }
    if (!sel.hasAttribute('data-plx-scent')) sel.setAttribute('data-plx-scent', '');
    syncPills(sel, wrap);
  }

  /* Appstle's selects are React-controlled: set the value, then call React's own onChange
     (a plain DOM change event gets reverted on the next render). */
  function pickScent(sel, value) {
    setSelect.call(sel, value);
    var pk = Object.keys(sel).filter(function (k) { return k.indexOf('__reactProps') === 0; })[0];
    if (pk && sel[pk] && typeof sel[pk].onChange === 'function') {
      sel[pk].onChange({ target: sel, currentTarget: sel, type: 'change', persist: function () {}, preventDefault: function () {}, stopPropagation: function () {} });
    } else {
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function syncPills(sel, wrap) {
    var btns = wrap.querySelectorAll('.plx-scent');
    for (var k = 0; k < btns.length; k++) {
      var on = btns[k].getAttribute('data-value') === sel.value;
      if (btns[k].classList.contains('is-on') !== on) btns[k].classList.toggle('is-on', on);
      var a = on ? 'true' : 'false';
      if (btns[k].getAttribute('aria-checked') !== a) btns[k].setAttribute('aria-checked', a);
    }
  }

  /* 4) Final check for reasons that have no retention offer (skin reacted, something else). Appstle
        cancels straight from the reason list for these, so the Cancel button is caught first and a
        last "Keep my subscription / Continue cancelling" step is shown inside the modal. Continue
        clicks Appstle's own button again (feedback text is kept, nothing is rebuilt). */
  var NO_OFFER = /skin reacted|something else/i;
  var CONTINUE_CANCEL = /continue cancel|no thanks/i;
  var letCancel = false, plxLastReason = '';
  // Oct 22: the picture shows once per cancel attempt. After CANCEL MY SUBSCRIPTION on it, Appstle may show its
  // fallback offer (20% off, set per reason in Appstle); declining that one cancels without the picture again.
  var plxDontgoDone = false;
  // the "No! Don't gooo…" picture (assets/pluxos-cancel-dontgo.jpg), next to this script on the CDN
  var DONTGO_IMG = (function () {
    var sc = document.querySelector('script[src*="pluxos-portal.js"]');
    return sc ? sc.src.replace(/pluxos-portal\.js.*$/, 'pluxos-cancel-dontgo.jpg') + '?v=2' : ''; // bump v when the pictures change
  })();
  var DONTGO_IMG_WIDE = DONTGO_IMG ? DONTGO_IMG.replace('pluxos-cancel-dontgo.jpg', 'pluxos-cancel-dontgo-wide.jpg') : ''; // desktop (2:1)
  function confirmCopy(reason) {
    if (/skin reacted/i.test(reason)) {
      return 'Thank you for telling us, your note goes straight to our team. If you cancel, your subscription stops and you won’t be charged again.';
    }
    return 'If you cancel, your subscription stops and you won’t be charged again. Just need a break? You can skip or pause instead.';
  }
  /* Oct 21: the last screen before ANY cancellation goes through. Caught in two places:
     (1) the reason list's Cancel button for the reasons with no offer, (2) "No thanks, continue cancelling"
     on an offer, whatever the reason. Shows the "No! Don't gooo…" picture with KEEP MY SUBSCRIPTION
     (closes the pop-up, nothing changes) / CANCEL MY SUBSCRIPTION (clicks Appstle's own button again, so
     feedback text and Appstle's own logic stay as they are; if Appstle shows a backup offer next, this
     screen comes again before that cancels). */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cancelSubscriptionModal button');
    if (!btn || btn.closest('.plx-confirm')) return;
    var m = btn.closest('.cancelSubscriptionModal');
    var isFinal = false, reason = '';
    if (btn.type === 'submit' && m.querySelector('#cancellationReason')) {
      var picked = m.querySelector('#cancellationReason input[type="radio"]:checked');
      var label = picked && picked.closest('label');
      reason = label ? (label.textContent || '').trim() : '';
      plxLastReason = reason;
      if (!letCancel) plxDontgoDone = false; // a new attempt from the reason list
      isFinal = NO_OFFER.test(reason); // the other reasons get Appstle's offer step first
    } else if (CONTINUE_CANCEL.test((btn.textContent || '').trim())) {
      isFinal = true;
      reason = plxLastReason;
    }
    if (!isFinal) return;
    if (letCancel) { letCancel = false; return; }
    if (plxDontgoDone) return; // picture already shown in this attempt: let Appstle carry on
    e.preventDefault();
    e.stopPropagation();
    var body = m.querySelector('.as-modal-body') || btn.parentElement;
    if (!body) return;
    var box = m.querySelector('.plx-confirm');
    if (box) box.remove();
    box = document.createElement('div');
    box.className = 'plx-confirm plx-confirm--dontgo';
    box.innerHTML =
      (DONTGO_IMG ? '<picture><source media="(min-width: 768px)" srcset="' + DONTGO_IMG_WIDE + '" width="1200" height="600">' +
        '<img class="plx-confirm__img" src="' + DONTGO_IMG + '" alt="No! Don’t gooo…" width="960" height="1200"></picture>' : '<p class="plx-confirm__title">Are you sure?</p>') +
      '<p class="plx-confirm__text"></p>' +
      '<div class="plx-confirm__btns">' +
        '<button type="button" class="as-button as-button--primary" data-plx-keep>Keep my subscription</button>' +
        '<button type="button" class="as-button as-button--secondary" data-plx-go>' + (/too expensive/i.test(reason) ? 'Cancel my subscription' : 'Continue cancelling subscription') + '</button>' +
      '</div>';
    box.querySelector('.plx-confirm__text').textContent = confirmCopy(reason);
    if (/too expensive/i.test(reason)) box.insertBefore(reactNote(), box.querySelector('.plx-confirm__btns')); // this picture's button really cancels
    body.appendChild(box);
    m.setAttribute('data-plx-confirm', '');
    body.scrollTop = 0;
    // the pop-up title (e.g. "20% off your next order" on an offer) reads "Before you go" on this screen
    // (desktop dialog: .as-modal-title; phone bottom sheet: the span next to the X)
    var xBtn = Array.prototype.filter.call(m.querySelectorAll('button'), function (b) {
      return /close/i.test((b.textContent || '') + (b.getAttribute('aria-label') || ''));
    })[0];
    var ttl = m.querySelector('.as-modal-title > span') || m.querySelector('.as-modal-title') ||
              (xBtn && xBtn.parentElement ? xBtn.parentElement.querySelector(':scope > span, :scope > h2, :scope > h3') : null);
    var ttlOld = ttl ? ttl.getAttribute('data-plx-text') : null;
    if (ttl) { ttl.setAttribute('data-plx-text', 'Before you go'); ttl.setAttribute('data-plx-title', ''); }
    function restoreTitle() { if (!ttl) return; ttl.removeAttribute('data-plx-title'); if (ttlOld === null) ttl.removeAttribute('data-plx-text'); else ttl.setAttribute('data-plx-text', ttlOld); }
    box.querySelector('[data-plx-keep]').addEventListener('click', function () {
      plxDontgoDone = false;
      box.remove();
      m.removeAttribute('data-plx-confirm');
      restoreTitle();
      var close = Array.prototype.filter.call(m.querySelectorAll('button'), function (b) {
        return /close/i.test((b.textContent || '') + (b.getAttribute('aria-label') || ''));
      })[0];
      if (close) close.click();
    });
    box.querySelector('[data-plx-go]').addEventListener('click', function () {
      box.remove();
      m.removeAttribute('data-plx-confirm');
      restoreTitle();
      plxDontgoDone = true;
      letCancel = true;
      btn.click();
      setTimeout(function () { letCancel = false; }, 1500);
    });
  }, true);

  /* 5) History tab: "17799" → "Order #17799" + PAID tag, "Billing Attempt" → "Billed on" (an order number
        means the charge went through), the order date is dropped when it is the same day, and the
        button reads "View order". Text changes go through data attributes only (React-safe). */
  /* 6) Details tab products box → one compact card: photo · name (bold) · description + scent ·
        price line ($37.40 $44.00 15% off), quantity on the right (desktop), totals underneath.
        Name/price/meta are our own small elements; Appstle's duplicates are only hidden. */
  function ensureEl(parent, cls, before) {
    var el = parent.querySelector(':scope > .' + cls);
    if (!el) {
      el = document.createElement('p');
      el.className = cls;
      parent.insertBefore(el, before || null);
    }
    return el;
  }
  function setHTML(el, html) { if (el.__plxHtml !== html) { el.innerHTML = html; el.__plxHtml = html; } }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var products = {};
  function productInfo(handle) {
    if (products[handle] !== undefined) return products[handle];
    products[handle] = null;
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (j) { products[handle] = j || {}; schedule(); })
      .catch(function () { products[handle] = {}; });
    return null;
  }
  function compactProducts() {
    var pt = document.querySelector('.as-product-details_title');
    if (pt) setText(pt, 'Products in this subscription');
    var rows = document.querySelectorAll('.as-product-details tr.as-product-line');
    var sumBase = 0, sumCmp = 0, allCmp = rows.length > 0;
    for (var i = 0; i < rows.length; i++) {
      var tr = rows[i];
      var details = tr.querySelector('.as-product-line-details');
      var a = tr.querySelector('.as-product-title a.as-product-title-tag-a');
      if (!details || !a) continue;
      var titleWrap = details.firstElementChild;
      var vEl = a.querySelector('.as-variant');
      var variant = vEl ? (vEl.textContent || '').replace(/^\s*-\s*/, '').trim() : '';
      var full = (a.textContent || '').replace(vEl ? vEl.textContent : '', '').trim();
      var parts = full.split('|');
      var name = parts[0].trim();
      var desc = parts.slice(1).join('|').trim();
      setText(a, name);
      var cur = tr.querySelector('.as-amount-value');
      var cmp = cur && cur.parentElement ? cur.parentElement.querySelector('span[style*="line-through"]') : null;
      var li = details.querySelector('ul:not(.as-cycle-discount) li');
      var pm = li ? (li.textContent || '').match(/\((\d+)%\s*off\)/i) : null;
      var pct = pm ? pm[1] + '% off' : '';
      var qIn = tr.querySelector('.as-product-line-quantity input');
      var qty = qIn ? parseInt(qIn.value, 10) : 1;
      var meta = ensureEl(details, 'plx-line-meta', titleWrap ? titleWrap.nextSibling : null);
      setHTML(meta, esc(desc) + (variant ? (desc ? ' · ' : '') + '<b>' + esc(variant) + '</b>' : ''));
      var price = ensureEl(details, 'plx-line-price', meta.nextSibling);
      var curTxt = cur ? (cur.textContent || '').trim() : '';
      var cmpTxt = cmp ? (cmp.textContent || '').trim() : '';
      // Use the product's compare-at price (as on the product page: $52 → 28% off) when it is higher
      var hm = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      var pd = hm ? productInfo(hm[1]) : null;
      if (!(pd && pd.variants)) allCmp = false;
      if (pd && pd.variants) {
        var v = pd.variants.length === 1 ? pd.variants[0] : pd.variants.filter(function (x) { return (x.title || '').toLowerCase() === variant.toLowerCase(); })[0];
        var curC = Math.round(parseFloat(curTxt.replace(/[^0-9.]/g, '')) * 100);
        var baseC = Math.round(parseFloat(((cmp && cmp.textContent) || curTxt).replace(/[^0-9.]/g, '')) * 100);
        if (v && v.compare_at_price && baseC > 0 && v.compare_at_price > baseC) { sumBase += baseC * qty; sumCmp += v.compare_at_price * qty; }
        if (v && baseC > 0) plxLinePrices[full.toLowerCase()] = { base: baseC, cmp: (v.compare_at_price && v.compare_at_price > baseC) ? v.compare_at_price : 0, pct: pm ? parseInt(pm[1], 10) : 0 };
        else allCmp = false;
        if (v && v.compare_at_price && curC > 0 && v.compare_at_price > curC) {
          cmpTxt = '$' + (v.compare_at_price / 100).toFixed(2);
          pct = Math.floor((v.compare_at_price - curC) * 100 / v.compare_at_price) + '% off';
        }
      }
      var ph = esc(curTxt);
      if (cmpTxt) ph += ' <s>' + esc(cmpTxt) + '</s>';
      if (pct) ph += ' <span class="plx-line-price__tag">' + esc(pct) + '</span>';
      if (qty > 1) ph += ' <span class="plx-line-price__qty">× ' + qty + '</span>';
      setHTML(price, ph);
      var amt = details.querySelector(':scope > .as-amount');
      if (amt && !amt.hasAttribute('data-plx-hide')) amt.setAttribute('data-plx-hide', '');
      var ul = li ? li.parentElement : null;
      if (ul && !ul.hasAttribute('data-plx-hide')) ul.setAttribute('data-plx-hide', '');
    }
    if (allCmp && sumCmp > 0) { var rr = sumBase / sumCmp; if (Math.abs(rr - plxPriceRatio) > 1e-9) { plxPriceRatio = rr; } }
    savePrices();
  }
  // the prices above are remembered for the visit (per subscription), so Deliveries shows the right 28% / 32%
  // and savings even when the Details tab hasn't been opened first (e.g. right after CANCEL SKIP)
  function priceKey() { var m = (location.hash || '').match(/subscriptions\/(\d+)/); return m ? 'plxPrices:' + m[1] : ''; }
  function savePrices() {
    var k = priceKey();
    if (!k || (!plxPriceRatio && !Object.keys(plxLinePrices).length)) return;
    var v = JSON.stringify({ r: plxPriceRatio, l: plxLinePrices, m: plxMonthly });
    try { if (sessionStorage.getItem(k) !== v) sessionStorage.setItem(k, v); } catch (e) {}
  }
  function loadPrices() {
    if (plxPriceRatio || Object.keys(plxLinePrices).length) return;
    var k = priceKey(), v = null;
    try { v = k ? JSON.parse(sessionStorage.getItem(k) || 'null') : null; } catch (e) {}
    if (!v) return;
    plxPriceRatio = v.r || 0; plxLinePrices = v.l || {}; if (typeof v.m === 'boolean') plxMonthly = v.m;
  }

  var orderTotals = null, orderLinks = {}, totalsLoading = false, orderData = {};
  function loadTotals() {
    if (totalsLoading) return;
    totalsLoading = true;
    fetch('/account', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var map = {};
      var rows = doc.querySelectorAll('.plx-acc__order');
      for (var i = 0; i < rows.length; i++) {
        var n = rows[i].querySelector('.plx-acc__order-name');
        var t = rows[i].querySelector('.plx-acc__order-total');
        var m = n && (n.textContent || '').match(/(\d+)/);
        if (m && t) map[m[1]] = (t.textContent || '').trim();
        if (m && rows[i].getAttribute('href')) orderLinks[m[1]] = rows[i].getAttribute('href');
      }
      orderTotals = map;
      schedule();
    }).catch(function () { orderTotals = {}; });
  }
  // full order details (items, shipping, tax, address, tracking) from the order page's JSON block
  function loadOrder(num) {
    if (orderData[num] !== undefined || !orderLinks[num]) return orderData[num] || null;
    orderData[num] = null;
    fetch(orderLinks[num], { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var el = doc.getElementById('plx-order-data');
      orderData[num] = el ? JSON.parse(el.textContent) : false;
      schedule();
    }).catch(function () { orderData[num] = false; });
    return null;
  }
  function sumRow(label, value, cls) {
    return '<div class="plx-hist-sum__row' + (cls ? ' ' + cls : '') + '"><span>' + esc(label) + '</span><span>' + esc(value) + '</span></div>';
  }
  function orderHTML(d) {
    var h = '';
    h += sumRow('Subtotal', d.subtotal);
    (d.discounts || []).forEach(function (x) { h += sumRow(x.title, '−' + x.amount, 'is-disc'); });
    if (d.shipping) h += sumRow('Shipping' + (d.shipping.title ? ' · ' + d.shipping.title : ''), d.shipping.price);
    if (d.tax) {
      var tl = '';
      (d.taxLines || []).forEach(function (t) { tl += sumRow(t.title + (t.rate > 0 ? ' (' + t.rate + '%)' : ''), t.price, 'is-tax'); });
      h += tl ? '<details class="plx-hist-tax"><summary class="plx-hist-sum__row"><span>Tax</span><span>' + esc(d.tax) + '</span></summary>' + tl + '</details>'
              : sumRow('Tax', d.tax);
    }
    if (d.refunded) h += sumRow('Refunded', '−' + d.refunded);
    h += sumRow('Total', d.total, 'is-total');
    var foot = '';
    if (d.address) foot += '<p class="plx-hist-sum__addr"><span>Ships to</span>' + esc(d.address) + '</p>';
    (d.tracking || []).forEach(function (t) {
      foot += '<a class="plx-btn plx-btn--sm plx-hist-sum__track" href="' + esc(t.url) + '" target="_blank" rel="noopener">Track package</a>';
    });
    return '<div class="plx-hist-sum__rows">' + h + '</div>' + (foot ? '<div class="plx-hist-sum__foot">' + foot + '</div>' : '');
  }

  function historyCards() {
    var cards = document.querySelectorAll('.appstle-history-tab-content > div > div');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      var h = c.querySelector('h3');
      var raw = h ? (h.textContent || '').trim() : '';
      var paid = /^#?\d+$/.test(raw);
      var num = raw.replace('#', '');
      if (!c.hasAttribute('data-plx-history')) c.setAttribute('data-plx-history', '');
      if (paid) setText(h, 'Order #' + num);
      var bill = c.querySelector('.as-billing-attempt-text');
      if (bill && paid) setText(bill, 'Billed on');
      var od = c.querySelector('.as-order-date');
      var bd = c.querySelector('.as-billing-attempt-date');
      var odd = od && od.querySelector('.as-date'), bdd = bd && bd.querySelector('.as-date');
      if (odd && bdd && odd.textContent.trim() === bdd.textContent.trim()) {
        if (!od.hasAttribute('data-plx-hide')) od.setAttribute('data-plx-hide', '');
      } else if (od && od.hasAttribute('data-plx-hide')) od.removeAttribute('data-plx-hide');
      var btn = c.querySelector('.as-view-order-details-button button');
      if (btn) setText(btn, 'View order');
      if (c.querySelector('.as-unSkip-order')) {
        // a skipped delivery: SKIPPED DELIVERY + date, SKIPPED tag, CANCEL SKIP; no pop-up button, no $0 total
        if (!c.hasAttribute('data-plx-skipped')) c.setAttribute('data-plx-skipped', '');
        var odt = c.querySelector('.as-order-date-text');
        if (odt) setText(odt, 'Skipped delivery');
        var vb0 = c.querySelector('.as-view-order-details-button');
        if (vb0 && !vb0.hasAttribute('data-plx-hide')) vb0.setAttribute('data-plx-hide', '');
        var tr0 = c.querySelector(':scope > div:last-child');
        if (tr0 && /total/i.test(tr0.textContent || '') && !tr0.querySelector('.as-col-span-3') && !tr0.hasAttribute('data-plx-hide')) tr0.setAttribute('data-plx-hide', '');
        continue;
      }
      if (!paid) continue;
      if (!orderTotals) { loadTotals(); }
      var d = orderTotals ? loadOrder(num) : null;
      var fin = d && d.financial ? d.financial : 'Paid';
      if (h.getAttribute('data-plx-paid') !== fin) h.setAttribute('data-plx-paid', fin);
      var tot = c.querySelector(':scope > div.as-flex:last-of-type > p') || c.querySelector(':scope > div:last-child > p');
      if (!d) {
        // no details yet / not found: Appstle's card with the corrected total and its View order pop-up
        if (tot && orderTotals && orderTotals[num]) setText(tot, orderTotals[num]);
        continue;
      }
      // details found: put everything on the card, drop the pop-up button and Appstle's total line
      var head = h.parentElement;
      var st = head.querySelector(':scope > .plx-hist-status');
      if (!st) { st = document.createElement('span'); st.className = 'plx-hist-status'; head.insertBefore(st, h.nextSibling); }
      if (st.textContent !== d.status) st.textContent = d.status;
      var vb = c.querySelector('.as-view-order-details-button');
      var vbw = vb && vb.parentElement;
      if (vbw && !vbw.hasAttribute('data-plx-hide')) vbw.setAttribute('data-plx-hide', '');
      var totRow = tot && tot.parentElement;
      if (totRow && !totRow.hasAttribute('data-plx-hide')) totRow.setAttribute('data-plx-hide', '');
      // price per product line
      var lines = c.querySelectorAll('.as-col-span-3');
      for (var k = 0; k < lines.length; k++) {
        var nm = ((lines[k].querySelector('p') || {}).textContent || '').trim().toLowerCase();
        var it = (d.items || []).filter(function (x) { return (x.product || '').trim().toLowerCase() === nm; })[0];
        if (!it) continue;
        var lp = lines[k].querySelector(':scope > .plx-hist-line');
        if (!lp) { lp = document.createElement('p'); lp.className = 'plx-hist-line'; lines[k].appendChild(lp); }
        setHTML(lp, esc(it.price) + (it.original ? ' <s>' + esc(it.original) + '</s>' : ''));
      }
      var sum = c.querySelector(':scope > section.plx-hist-sum');
      if (!sum) { sum = document.createElement('section'); sum.className = 'plx-hist-sum'; c.appendChild(sum); }
      setHTML(sum, orderHTML(d));
    }
  }

  /* 7) Subscription header: "Created on Mon, 19th October 2026 | Current Billing Cycle 1st" → two clear facts
        in a grey panel: SUBSCRIBED SINCE October 19, 2026 · ORDERS SO FAR 1. Appstle's line is only hidden. */
  function subFacts() {
    var heads = document.querySelectorAll('.as-subscription-detail-header');
    for (var i = 0; i < heads.length; i++) {
      var line = heads[i].nextElementSibling;
      if (!line || line.classList.contains('plx-sub-facts')) line = line && line.nextElementSibling;
      if (!line || !/Created on/i.test(line.textContent || '')) continue;
      var t = (line.textContent || '').replace(/\s+/g, ' ');
      var dm = t.match(/Created on\s+(?:[A-Za-z]+,\s*)?(\d+)(?:st|nd|rd|th)?\s+([A-Za-z]+)\s+(\d{4})/i);
      var since = dm ? dm[2] + ' ' + dm[1] + ', ' + dm[3] : '';
      var cEl = line.querySelector('.as-current-billing-count');
      var n = cEl ? parseInt(cEl.textContent, 10) : NaN;
      var html = '';
      if (since) html += '<div class="plx-sub-facts__item"><span>Subscribed since</span><b>' + esc(since) + '</b></div>';
      if (!isNaN(n)) html += '<div class="plx-sub-facts__item"><span>Orders so far</span><b>' + n + '</b></div>';
      if (!html) continue;
      var box = line.parentNode.querySelector(':scope > .plx-sub-facts');
      if (!box) { box = document.createElement('div'); box.className = 'plx-sub-facts'; line.parentNode.insertBefore(box, line.nextSibling); }
      setHTML(box, html);
      if (!line.hasAttribute('data-plx-hide')) line.setAttribute('data-plx-hide', '');
    }
  }

  /* 8) Scheduled + History product lines: short bold name + description line (like the Details card),
        "Variant" → Scent, "Quantity" → Qty on one line each, and the repeated "Next order date" line
        hidden (the card's own heading already shows the date). Labels via data attributes only. */
  function tidyLines() {
    var cols = document.querySelectorAll('.appstle-fulfilment-tab-content .as-col-span-3, .appstle-history-tab-content .as-col-span-3');
    for (var i = 0; i < cols.length; i++) {
      var col = cols[i];
      if (!col.hasAttribute('data-plx-line')) col.setAttribute('data-plx-line', '');
      var t = col.querySelector(':scope > p');
      if (!t) continue;
      var full = (t.textContent || '').trim();
      var parts = full.split('|');
      if (parts.length > 1) {
        setText(t, parts[0].trim());
        var meta = ensureEl(col, 'plx-line-meta', t.nextSibling);
        var d = parts.slice(1).join('|').trim();
        if (meta.textContent !== d) meta.textContent = d;
      }
      var ps = col.querySelectorAll(':scope > p');
      for (var k = 1; k < ps.length; k++) {
        var lab = ps[k].querySelector('span');
        if (!lab) continue;
        var lt = (lab.textContent || '').toLowerCase();
        if (/next order date/.test(lt)) { if (!ps[k].hasAttribute('data-plx-hide')) ps[k].setAttribute('data-plx-hide', ''); }
        else if (/variant/.test(lt)) setText(lab, 'Scent');
        else if (/quantity/.test(lt)) setText(lab, 'Qty');
      }
    }
  }

  /* 9) Tab name: "Scheduled" → "Deliveries" */
  function renameTabs() {
    var tabs = document.querySelectorAll('.as-cp-wrapper [role="tab"], .as-cp-wrapper .as-tab-item');
    for (var i = 0; i < tabs.length; i++) {
      if (/^\s*scheduled\s*$/i.test(tabs[i].textContent || '')) setText(tabs[i], 'Deliveries');
    }
  }

  /* 10) Deliveries tab rewards.
         - Cards that include a reward: black tags "REWARD: 32% OFF" / "REWARD: FREE DUSK" (% shown vs the
           compare-at price, like the product page) + "Included in this order".
         - Cards with no reward: no tag; instead a small progress bar to the next reward found on a later card:
           NEXT REWARD · 32% OFF · DEC 19, one segment per order, "Stay subscribed 1 more order to unlock". */
  var MONTHS = { january: 'Jan', february: 'Feb', march: 'Mar', april: 'Apr', may: 'May', june: 'Jun', july: 'Jul', august: 'Aug', september: 'Sep', october: 'Oct', november: 'Nov', december: 'Dec' };
  function shortDate(t) {
    var m = (t || '').match(/(\d+)(?:st|nd|rd|th)?\s+([A-Za-z]+)/);
    return m ? (MONTHS[m[2].toLowerCase()] || m[2].slice(0, 3)) + ' ' + m[1] : (t || '').trim();
  }
  function rewardName(t) {
    t = (t || '').trim();
    var g = t.match(/^free (?:product|gift)\s*:\s*([^|]+)/i);
    if (g) return 'Free ' + g[1].trim();
    var p = t.match(/^(\d+)\s*%\s*off$/i);
    if (p && plxPriceRatio) return Math.floor((1 - (1 - parseInt(p[1], 10) / 100) * plxPriceRatio) * 100 + 1e-6) + '% off';
    return t;
  }
  function rewardChips() {
    var wrap = document.querySelector('.appstle-fulfilment-tab-content');
    if (!wrap) return;
    var cards = Array.prototype.slice.call(wrap.children).filter(function (c) { return c.querySelector('.as-order-scheduled-date'); });
    var info = cards.map(function (c) {
      var chips = c.querySelectorAll('.as-reward-chip');
      var names = Array.prototype.map.call(chips, function (ch) { return rewardName(ch.textContent); });
      return { el: c, chips: chips, names: names, date: shortDate((c.querySelector('.as-order-scheduled-date') || {}).textContent) };
    });
    var cEl = document.querySelector('.as-current-billing-count');
    var done = cEl ? parseInt(cEl.textContent, 10) : NaN;
    for (var i = 0; i < info.length; i++) {
      var it = info[i];
      for (var k = 0; k < it.chips.length; k++) setText(it.chips[k], 'Reward: ' + it.names[k]);
      var nudge = it.el.querySelector('.as-gift-nudge');
      var box = it.el.querySelector('.as-upcoming-order-rewards');
      if (it.chips.length || !box) continue;
      // no reward on this delivery: progress to the next one
      var j = -1;
      for (var q = i + 1; q < info.length; q++) { if (info[q].chips.length) { j = q; break; } }
      var html;
      if (j > -1) {
        var ahead = j - i;
        var thisNo = isNaN(done) ? i + 1 : done + 1 + i;
        var rewardNo = isNaN(done) ? j + 1 : done + 1 + j;
        var segs = '';
        for (var sIdx = 1; sIdx <= rewardNo; sIdx++) segs += '<i class="' + (sIdx <= thisNo ? 'is-on' : (sIdx === rewardNo ? 'is-reward' : '')) + '"></i>';
        html = '<div class="plx-progress__top"><span>Next reward</span><b>' + esc(info[j].names.join(' + ')) + ' · ' + esc(info[j].date) + '</b></div>' +
               '<div class="plx-progress__bar">' + segs + '</div>' +
               '<p class="plx-progress__note">Stay subscribed ' + ahead + ' more order' + (ahead === 1 ? '' : 's') + ' to unlock</p>';
      } else if (nudge) {
        var nm = (nudge.textContent || '').match(/(\d+)\s+orders?\s+away/i);
        var n2 = nm ? parseInt(nm[1], 10) : 0;
        var sg = '';
        for (var z = 0; z <= n2; z++) sg += '<i class="' + (z === 0 ? 'is-on' : (z === n2 ? 'is-reward' : '')) + '"></i>';
        html = '<div class="plx-progress__top"><span>Next reward</span><b>Free gift</b></div>' + (n2 ? '<div class="plx-progress__bar">' + sg + '</div>' : '') +
               '<p class="plx-progress__note">' + (n2 ? 'Stay subscribed ' + n2 + ' more order' + (n2 === 1 ? '' : 's') + ' to unlock' : esc(nudge.textContent)) + '</p>';
      } else continue;
      var pr = box.querySelector(':scope > .plx-progress');
      if (!pr) { pr = document.createElement('div'); pr.className = 'plx-progress'; box.appendChild(pr); }
      setHTML(pr, html);
      if (nudge && !nudge.hasAttribute('data-plx-hide')) nudge.setAttribute('data-plx-hide', '');
    }
  }

  /* 11) Deliveries cards: MONTH n tag above the date (Oct 19 = month 1) and a savings line under each product:
         $37.40 $52.00 28% OFF / You save $14.60 (32% from the 20% order onward). Prices come from the Details
         card (Appstle base price, the order's % and the product's compare-at price). */
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function deliveryExtras() {
    var fq = document.querySelector('.as-edit-frequency');
    if (fq) plxMonthly = /every\s*1\s*month(?!s)/i.test(fq.textContent || '') || /every\s+month(?!s)/i.test(fq.textContent || '');
    var wrap = document.querySelector('.appstle-fulfilment-tab-content');
    if (!wrap) return;
    var cEl = document.querySelector('.as-current-billing-count');
    var done = cEl ? parseInt(cEl.textContent, 10) : NaN;
    var cards = Array.prototype.slice.call(wrap.children).filter(function (c) { return c.querySelector('.as-order-scheduled-date'); });
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var head = card.firstElementChild;
      if (head && !isNaN(done)) {
        // tag row above the date: MONTH n, plus UPCOMING DELIVERY on the next delivery (addToOrder decides which)
        var row = head.querySelector(':scope > .plx-tagrow');
        if (!row) { row = document.createElement('div'); row.className = 'plx-tagrow'; head.insertBefore(row, head.firstChild); }
        var tag = row.querySelector(':scope > .plx-month');
        if (!tag) { tag = document.createElement('span'); tag.className = 'plx-month'; row.insertBefore(tag, row.firstChild); }
        var label = (plxMonthly ? 'Month ' : 'Order ') + (done + 1 + i);
        if (tag.textContent !== label) tag.textContent = label;
        var isNext = card === nextDeliveryCard(cards);
        var up = row.querySelector(':scope > .plx-upnext');
        if (isNext && !up) { up = document.createElement('span'); up.className = 'plx-upnext'; up.textContent = 'Upcoming delivery'; row.appendChild(up); }
        if (!isNext && up) up.remove();
      }
      // the % this delivery gets: a % reward chip on the card, else the product's current %
      var chipPct = 0;
      var chips = card.querySelectorAll('.as-reward-chip');
      for (var k = 0; k < chips.length; k++) { var m = (chips[k].textContent || '').match(/^(\d+)\s*%\s*off/i); if (m) chipPct = parseInt(m[1], 10); }
      var cols = card.querySelectorAll('.as-col-span-3');
      for (var q = 0; q < cols.length; q++) {
        var t = cols[q].querySelector(':scope > p');
        if (!t) continue;
        var lp = plxLinePrices[(t.textContent || '').trim().toLowerCase()];
        if (!lp) continue;
        var qtyEl = cols[q].querySelector('.as-quantity .as-value');
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
        var d = chipPct || lp.pct;
        var pay = Math.round(lp.base * (100 - d) / 100) * qty;
        var cmp = (lp.cmp || lp.base) * qty;
        var off = cmp > pay ? Math.floor((cmp - pay) * 100 / cmp) : 0;
        var html = '<span class="plx-dl-price__now">' + money(pay) + '</span>' + (cmp > pay ? ' <s>' + money(cmp) + '</s> <span class="plx-dl-price__tag">' + off + '% off</span>' : '');
        if (cmp > pay) html += '<span class="plx-dl-price__save">You save ' + money(cmp - pay) + '</span>';
        var el = cols[q].querySelector(':scope > .plx-dl-price');
        if (!el) { el = document.createElement('p'); el.className = 'plx-dl-price'; cols[q].appendChild(el); }
        setHTML(el, html);
      }
    }
  }

  /* 12) Number the subscriptions: SUBSCRIPTION 1, 2, 3… on each list card with "ID #59598799023" on a small
         line under it, so people can count their subscriptions at a glance. The list order is remembered
         (sessionStorage) so the detail page header shows the same number. */
  function numberSubs() {
    // Oct 22 (owner): same order + numbers as My Account (plxSubs.sort): live subscriptions (active, then paused)
    // first and numbered 1, 2, 3…; cancelled ones after them, no number. Uses the order My Account saved
    // (sessionStorage plxSubOrder); without it, live cards are numbered in Appstle's order.
    var cards = document.querySelectorAll('.as-card.as-subscription');
    var order = [];
    try { order = (sessionStorage.getItem('plxSubOrder') || '').split(',').filter(Boolean); } catch (e) {}
    var info = [];
    for (var i = 0; i < cards.length; i++) {
      var h = cards[i].querySelector('.as-subscription-header h3');
      if (!h) continue;
      var idEl = h.querySelector('.as-contract-id');
      var st = ((h.querySelector('.as-status') || {}).textContent || '').trim().toLowerCase();
      info.push({ card: cards[i], h: h, lab: h.querySelector('.as-label'), idEl: idEl, id: idEl ? (idEl.textContent || '').replace(/[^0-9]/g, '') : '',
        rank: /^active/.test(st) ? 0 : /^paused/.test(st) ? 1 : 2, dom: i });
    }
    var live = info.filter(function (o) { return o.rank < 2; });
    live.sort(function (a, b) {
      var ia = order.indexOf(a.id), ib = order.indexOf(b.id);
      if (ia > -1 && ib > -1) return ia - ib;
      if (ia > -1 || ib > -1) return ia > -1 ? -1 : 1;
      return a.rank - b.rank || a.dom - b.dom;
    });
    live.forEach(function (o, k) { o.num = k + 1; o.pos = k; });
    var off = info.filter(function (o) { return o.rank === 2; });
    off.forEach(function (o, k) { o.num = 0; o.pos = live.length + k; });
    info.forEach(function (o) {
      if (o.lab) setText(o.lab, o.num ? 'Subscription ' + o.num : 'Subscription');
      if (o.idEl && o.id) setText(o.idEl, 'ID #' + o.id);
      if (!o.h.hasAttribute('data-plx-subnum')) o.h.setAttribute('data-plx-subnum', '');
    });
    // put the cards in that order (CSS order on each card's wrapper inside the list)
    if (info.length > 1) {
      var lca = info[0].card.parentElement;
      while (lca && !info.every(function (o) { return lca.contains(o.card); })) lca = lca.parentElement;
      if (lca) {
        if (lca.style.display !== 'flex') { lca.style.display = 'flex'; lca.style.flexDirection = 'column'; }
        info.forEach(function (o) {
          var w = o.card; while (w.parentElement && w.parentElement !== lca) w = w.parentElement;
          if (w.style.order !== String(o.pos)) w.style.order = String(o.pos);
        });
      }
    }
    if (!order.length && live.length) { try { sessionStorage.setItem('plxSubOrder', live.map(function (o) { return o.id; }).join(',')); } catch (e) {} }
    if (live.length) order = live.map(function (o) { return o.id; });
    var dh = document.querySelector('.as-subscription-detail-header_title');
    if (dh) {
      var dl = dh.querySelector('.as-label:not(.as-subscription-id)');
      var di = dh.querySelector('.as-subscription-id');
      var did = di ? (di.textContent || '').replace(/[^0-9]/g, '') : '';
      var n = did ? order.indexOf(did) + 1 : 0;
      if (dl) setText(dl, n > 0 ? 'Subscription ' + n : 'Subscription');
      if (di && did) setText(di, 'ID #' + did);
      if (!dh.hasAttribute('data-plx-subnum')) dh.setAttribute('data-plx-subnum', '');
    }
  }

  /* 13) Paused / cancelled subscriptions: Appstle's own resume / reactivate button is always shown on the list
         card, right under MANAGE SUBSCRIPTION, as a full-width button labelled REACTIVATE SUBSCRIPTION (pause and
         cancel stay hidden there). Found by its wording, so it works whatever class Appstle gives it. */
  var RE_REACT = /\b(resume|re-?activate|activate|restart|unpause)\b/i;
  function reactivateButtons() {
    var wraps = document.querySelectorAll('.as-card.as-subscription .appstle-contract-cancel-and-detail-wrapper, .as-card.as-subscription .appstle-contract-action-wrapper');
    for (var i = 0; i < wraps.length; i++) {
      var btns = wraps[i].querySelectorAll('button, a');
      for (var k = 0; k < btns.length; k++) {
        var b = btns[k];
        if (b.closest('a.as-see-more-link')) continue;
        var t = (b.textContent || '').trim();
        if (!RE_REACT.test(t)) continue;
        if (!b.hasAttribute('data-plx-reactivate')) b.setAttribute('data-plx-reactivate', '');
        setText(b, 'Reactivate subscription');
        var holder = b.parentElement;
        while (holder && holder.parentElement && !holder.parentElement.classList.contains('appstle-contract-cancel-and-detail-wrapper') && holder !== wraps[i]) holder = holder.parentElement;
        if (holder && holder !== b && !holder.hasAttribute('data-plx-reactivate-holder')) holder.setAttribute('data-plx-reactivate-holder', '');
      }
    }
  }

  /* 14) Skipped deliveries stay visible in Deliveries (Appstle drops them from that list and only shows them in
         History). Each skipped date gets its own card, in date order: SKIPPED tag, the date, "Nothing will be
         sent or charged…", and a CANCEL SKIP button (Appstle's own unskip call, then the page reloads so every
         date and reward updates). History's "Unskip order" link reads CANCEL SKIP as a button too. */
  var MONTH_IDX = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
  var skipState = { cid: '', sig: null, list: null, busy: false };
  function contractId() { var m = (location.hash || '').match(/subscriptions\/(\d+)/); return m ? m[1] : ''; }
  function apiUrl(path) {
    var t = '';
    try { t = sessionStorage.getItem('customerToken') || ''; } catch (e) {}
    return '/apps/subscriptions/cp/api/' + path + (path.indexOf('?') > -1 ? '&' : '?') + 'token=' + encodeURIComponent(t);
  }
  function cardDate(t) {
    var m = (t || '').match(/(\d+)(?:st|nd|rd|th)?\s+([A-Za-z]+)\s+(\d{4})/);
    if (!m) return null;
    var mi = MONTH_IDX.indexOf(m[2].toLowerCase());
    return mi < 0 ? null : new Date(parseInt(m[3], 10), mi, parseInt(m[1], 10));
  }
  function longDate(d) {
    var n = d.getDate(), s = (n % 10 === 1 && n !== 11) ? 'st' : (n % 10 === 2 && n !== 12) ? 'nd' : (n % 10 === 3 && n !== 13) ? 'rd' : 'th';
    return d.toLocaleDateString('en-US', { weekday: 'short' }) + ', ' + n + s + ' ' + d.toLocaleDateString('en-US', { month: 'long' }) + ' ' + d.getFullYear();
  }
  function shortD(d) { return d.toLocaleDateString('en-US', { month: 'short' }) + ' ' + d.getDate(); }
  function loadSkipped(cid) {
    skipState.busy = true;
    fetch(apiUrl('subscription-billing-attempts/past-orders?contractId=' + cid + '&page=0&size=20'), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : []; })
      .then(function (j) {
        var today = new Date(); today.setHours(0, 0, 0, 0);
        skipState.list = (Array.isArray(j) ? j : []).filter(function (o) {
          return o && o.status === 'SKIPPED' && o.id && o.billingDate && new Date(o.billingDate) >= today;
        }).map(function (o) { var d = new Date(o.billingDate); return { id: String(o.id), date: new Date(d.getFullYear(), d.getMonth(), d.getDate()) }; })
          .sort(function (a, b) { return a.date - b.date; });
        skipState.cid = cid; skipState.busy = false; schedule();
      })
      .catch(function () { skipState.list = []; skipState.cid = cid; skipState.busy = false; });
  }
  function skippedCards() {
    var wrap = document.querySelector('.appstle-fulfilment-tab-content');
    var cid = contractId();
    if (!wrap || !cid) return;
    var cards = Array.prototype.slice.call(wrap.children).filter(function (c) { return c.querySelector('.as-order-scheduled-date'); });
    var dates = cards.map(function (c) { return (c.querySelector('.as-order-scheduled-date').textContent || '').trim(); });
    // (re)load whenever the list of upcoming dates changes, e.g. right after a Skip
    var sig = cid + '|' + dates.join('|');
    if (sig !== skipState.sig && !skipState.busy) { skipState.sig = sig; loadSkipped(cid); }
    var list = skipState.cid === cid && skipState.list ? skipState.list : [];
    var keep = {};
    list.forEach(function (s) { keep[s.id] = 1; });
    Array.prototype.forEach.call(wrap.querySelectorAll(':scope > .plx-skipcard'), function (m) { if (!keep[m.getAttribute('data-plx-skip')]) m.remove(); });
    if (!list.length) return;
    // everything in date order: Appstle's cards + ours
    var items = cards.map(function (c, i) { return { date: cardDate(dates[i]), el: c }; }).filter(function (x) { return x.date; });
    list.forEach(function (s) {
      var el = wrap.querySelector(':scope > .plx-skipcard[data-plx-skip="' + s.id + '"]');
      if (!el) { el = document.createElement('div'); el.className = 'plx-skipcard'; el.setAttribute('data-plx-skip', s.id); }
      var next = null;
      for (var q = 0; q < items.length; q++) { if (items[q].date > s.date) { next = items[q].date; break; } }
      var html = '<p class="plx-skip__tags"><span class="plx-skip__tag">Skipped</span></p>' +
        '<h3 class="plx-skip__date">' + esc(longDate(s.date)) + '</h3>' +
        '<div class="plx-skip__panel"><p class="plx-skip__title">This delivery is skipped</p>' +
        '<p class="plx-skip__note">Nothing will be sent or charged on ' + shortD(s.date) + '.' + (next ? ' Your next delivery is ' + shortD(next) + '.' : '') + '</p></div>' +
        '<div class="plx-skip__actions"><button type="button" class="plx-btn" data-plx-unskip="' + esc(s.id) + '" data-plx-date="' + s.date.getFullYear() + '-' + (s.date.getMonth() + 1) + '-' + s.date.getDate() + '">Cancel skip</button>' +
        '<p class="plx-skip__msg" role="status"></p></div>';
      setHTML(el, html);
      items.push({ date: s.date, el: el });
    });
    items.sort(function (a, b) { return a.date - b.date || (a.el.classList.contains('plx-skipcard') ? -1 : 1); });
    // place ours from the last one back, each right before whatever follows it
    var lastCard = cards[cards.length - 1] || null;
    for (var k = items.length - 1; k >= 0; k--) {
      var it = items[k];
      if (!it.el.classList.contains('plx-skipcard')) continue;
      var ref = k + 1 < items.length ? items[k + 1].el : null;
      if (ref) { if (it.el.nextElementSibling !== ref || it.el.parentNode !== wrap) wrap.insertBefore(it.el, ref); }
      else if (lastCard) { if (lastCard.nextElementSibling !== it.el) wrap.insertBefore(it.el, lastCard.nextElementSibling); }
      else if (it.el.parentNode !== wrap) wrap.appendChild(it.el);
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-plx-unskip]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var cid = contractId();
    var msg = b.parentNode.querySelector('.plx-skip__msg');
    b.disabled = true; b.textContent = 'Cancelling skip…';
    if (msg) msg.textContent = '';
    fetch(apiUrl('subscription-billing-attempts/unskip-order/' + encodeURIComponent(b.getAttribute('data-plx-unskip')) + '?subscriptionContractId=' + cid), { method: 'PUT', credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        b.textContent = 'Skip cancelled';
        if (msg) msg.textContent = 'This delivery is back on. Updating…';
        // after the reload: back on DELIVERIES, scrolled to the delivery that is on again (afterUnskip)
        try { sessionStorage.setItem('plxAfterUnskip', JSON.stringify({ date: b.getAttribute('data-plx-date'), cid: cid, t: Date.now() })); } catch (e) {}
        setTimeout(function () { location.reload(); }, 900);
      })
      .catch(function () {
        b.disabled = false; b.textContent = 'Cancel skip';
        if (msg) msg.textContent = "Couldn't cancel the skip. Please try again.";
      });
  });
  var plxAfter = null, plxPageStart = Date.now();
  try { plxAfter = JSON.parse(sessionStorage.getItem('plxAfterUnskip') || 'null'); } catch (e) {}
  function afterUnskip() {
    if (!plxAfter) return;
    var done = function () { plxAfter = null; try { sessionStorage.removeItem('plxAfterUnskip'); } catch (e) {} };
    if (Date.now() - plxAfter.t > 60000 || (contractId() && contractId() !== plxAfter.cid)) { done(); return; }
    var wrap = document.querySelector('.appstle-fulfilment-tab-content');
    if (!wrap) {
      // wait (max 8s) until the Details card has worked out the prices, so the 28% / 32% figures are right
      var ready = plxPriceRatio || Object.keys(plxLinePrices).length || Date.now() - plxPageStart > 8000;
      if (!plxAfter.clicked && ready) {
        var tabs = document.querySelectorAll('.as-cp-wrapper [role="tab"], .as-cp-wrapper .as-tab-item');
        for (var i = 0; i < tabs.length; i++) {
          if (/^\s*(scheduled|deliveries)\s*$/i.test(tabs[i].textContent || '')) { plxAfter.clicked = true; tabs[i].click(); break; }
        }
      }
      return;
    }
    var p = (plxAfter.date || '').split('-');
    var want = p.length === 3 ? new Date(+p[0], +p[1] - 1, +p[2]).getTime() : 0;
    var ds = wrap.querySelectorAll('.as-order-scheduled-date');
    for (var k = 0; k < ds.length; k++) {
      var d = cardDate(ds[k].textContent);
      if (!d || d.getTime() !== want) continue;
      var card = ds[k].closest('.appstle-fulfilment-tab-content > div');
      done();
      if (!card) return;
      card.classList.add('plx-back-on');
      setTimeout(function () {
        // scroll only when the card starts below the top part of the screen (the first card already shows under the tabs)
        var top = card.getBoundingClientRect().top;
        if (top > window.innerHeight * 0.6 || top < 0) window.scrollTo({ top: Math.max(0, top + window.pageYOffset - 90), behavior: 'smooth' });
      }, 350);
      setTimeout(function () { card.classList.remove('plx-back-on'); }, 3200);
      return;
    }
  }
  function historyUnskip() {
    var links = document.querySelectorAll('.appstle-history-tab-content .as-unSkip-order');
    for (var i = 0; i < links.length; i++) {
      if (!links[i].hasAttribute('data-plx-unskip-link')) links[i].setAttribute('data-plx-unskip-link', '');
      setText(links[i], 'Cancel skip');
    }
  }

  /* 15) ADD TO ORDER on every upcoming delivery card (Oct 21). The next delivery (the contract's next billing
         date) carries an UPCOMING DELIVERY tag; there the pop-up offers One-time (this delivery only, regular
         price) or Add to my subscription (every delivery, subscription price). Later cards offer Add to my
         subscription only (Appstle can put one-time extras on the next order only). Extras on a card get a
         Remove link: one-time extras, and products added to the subscription when there is more than one. */
  var addState = { cid: '', contract: null, busy: false, products: null, loadingProducts: false };
  function loadContract(cid) {
    addState.busy = true;
    fetch(apiUrl('subscription-contracts/contract-external/' + cid), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { addState.contract = j; addState.cid = cid; addState.busy = false; schedule(); })
      .catch(function () { addState.contract = null; addState.cid = cid; addState.busy = false; });
  }
  function contractLines() {
    var c = addState.contract;
    var l = c && c.lines ? (c.lines.nodes || (c.lines.edges || []).map(function (e) { return e.node; })) : [];
    return (l || []).filter(Boolean);
  }
  function isOneTimeLine(n) {
    return (n.customAttributes || []).some(function (a) { return a && a.key === '_appstle-one-time-product' && String(a.value) === 'true'; });
  }
  function nextBillingDay() {
    var c = addState.contract;
    if (!c || !c.nextBillingDate) return null;
    var d = new Date(c.nextBillingDate);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }
  function nextDeliveryCard(cards) {
    if (!cards.length) return null;
    var nb = nextBillingDay();
    if (nb) {
      for (var i = 0; i < cards.length; i++) {
        var d = cardDate((cards[i].querySelector('.as-order-scheduled-date') || {}).textContent);
        if (d && d.getTime() === nb.getTime()) return cards[i];
      }
    }
    return cards[0];
  }
  function ymd(d) { return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(); }
  function addToOrder() {
    var wrap = document.querySelector('.appstle-fulfilment-tab-content');
    var cid = contractId();
    if (!wrap || !cid) return;
    if (addState.cid !== cid && !addState.busy) loadContract(cid);
    var cards = Array.prototype.slice.call(wrap.children).filter(function (c) { return c.querySelector('.as-order-scheduled-date'); });
    var next = nextDeliveryCard(cards);
    var lines = addState.cid === cid ? contractLines() : [];
    var recurring = lines.filter(function (n) { return !isOneTimeLine(n); });
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var d = cardDate(card.querySelector('.as-order-scheduled-date').textContent);
      if (!d) continue;
      var isNext = card === next;
      // the button row, under the products
      var box = card.querySelector(':scope > .as-border-t');
      var rowEl = card.querySelector(':scope > .plx-addrow');
      if (!rowEl) {
        rowEl = document.createElement('div'); rowEl.className = 'plx-addrow';
        rowEl.innerHTML = '<button type="button" class="plx-btn plx-addbtn" data-plx-add><span aria-hidden="true">+</span> Add to order</button>';
        card.insertBefore(rowEl, box ? box.nextSibling : null);
      }
      var btn = rowEl.querySelector('[data-plx-add]');
      if (btn.getAttribute('data-plx-add') !== ymd(d)) btn.setAttribute('data-plx-add', ymd(d));
      if (btn.getAttribute('data-plx-next') !== (isNext ? '1' : '0')) btn.setAttribute('data-plx-next', isNext ? '1' : '0');
      // Remove links on extras
      if (!lines.length) continue;
      var cols = card.querySelectorAll('.as-col-span-3');
      for (var q = 0; q < cols.length; q++) {
        var col = cols[q];
        var tEl = col.querySelector(':scope > .as-product-title');
        if (!tEl) continue;
        var title = (tEl.textContent || '').trim();
        var vEl = col.querySelector('.as-variant .as-value');
        var vt = vEl ? (vEl.textContent || '').trim() : '';
        var oneTime = /one\s*time purchase/i.test(col.textContent || '');
        var pool = oneTime ? lines.filter(isOneTimeLine) : recurring;
        var line = pool.filter(function (n) {
          return (n.title || '').trim() === title && (!vt || (n.variantTitle || '').trim() === vt);
        })[0];
        // a product just added has no price line yet (prices come from the Details tab): use the subscription's price
        if (line && !col.querySelector(':scope > .plx-dl-price') && line.currentPrice) {
          var qEl = col.querySelector('.as-quantity .as-value');
          var pc = Math.round(parseFloat(line.currentPrice.amount) * 100) * (qEl ? parseInt(qEl.textContent, 10) || 1 : 1);
          var pe = document.createElement('p'); pe.className = 'plx-dl-price';
          pe.innerHTML = '<span class="plx-dl-price__now">' + money(pc) + '</span>';
          var oneTag = col.querySelector(':scope > [data-plx-onetime-tag]');
          col.insertBefore(pe, oneTag ? oneTag.nextSibling : col.querySelector(':scope > .plx-rm'));
        }
        var can = line && (oneTime || recurring.length > 1);
        var rm = col.querySelector(':scope > .plx-rm');
        if (!can) { if (rm) rm.remove(); continue; }
        if (!rm) { rm = document.createElement('p'); rm.className = 'plx-rm'; col.appendChild(rm); }
        if (rm.getAttribute('data-plx-line-id') !== line.id || rm.getAttribute('data-plx-onetime') !== (oneTime ? '1' : '0')) {
          rm.setAttribute('data-plx-line-id', line.id);
          rm.setAttribute('data-plx-onetime', oneTime ? '1' : '0');
          rm.setAttribute('data-plx-date', ymd(d));
          rm.innerHTML = '<button type="button" class="plx-rm__link" data-plx-rm>Remove</button>';
          rm.__plxHtml = null;
        }
        if (oneTime) { var tagEl = col.querySelector(':scope > p.as-text-xs:not(.as-quantity):not(.as-variant):not(.as-next-order-date)'); if (tagEl && /one\s*time/i.test(tagEl.textContent) && !tagEl.hasAttribute('data-plx-onetime-tag')) tagEl.setAttribute('data-plx-onetime-tag', ''); }
      }
    }
  }
  // Remove: inline "Remove from this delivery? / every delivery?" then Appstle's remove call and a reload
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.plx-rm [data-plx-rm], .plx-rm [data-plx-rm-yes], .plx-rm [data-plx-rm-no]');
    if (!b) return;
    e.preventDefault();
    var rm = b.closest('.plx-rm');
    var oneTime = rm.getAttribute('data-plx-onetime') === '1';
    if (b.hasAttribute('data-plx-rm')) {
      rm.innerHTML = '<span class="plx-rm__q">' + (oneTime ? 'Remove from this delivery?' : 'Remove from every delivery?') + '</span>' +
        '<button type="button" class="plx-rm__link plx-rm__link--strong" data-plx-rm-yes>Remove</button>' +
        '<button type="button" class="plx-rm__link" data-plx-rm-no>Keep</button>';
      return;
    }
    if (b.hasAttribute('data-plx-rm-no')) { rm.innerHTML = '<button type="button" class="plx-rm__link" data-plx-rm>Remove</button>'; return; }
    var cid = contractId();
    rm.innerHTML = '<span class="plx-rm__q">Removing…</span>';
    fetch(apiUrl('subscription-contracts-remove-line-item?contractId=' + cid + '&lineId=' + encodeURIComponent(rm.getAttribute('data-plx-line-id')) + '&isExternal=true&removeDiscount=true'), { method: 'PUT', credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        rm.innerHTML = '<span class="plx-rm__q">Removed. Updating…</span>';
        try { sessionStorage.setItem('plxAfterUnskip', JSON.stringify({ date: rm.getAttribute('data-plx-date'), cid: cid, t: Date.now() })); } catch (err) {}
        setTimeout(function () { location.reload(); }, 700);
      })
      .catch(function () {
        rm.innerHTML = '<span class="plx-rm__q">Couldn\'t remove it. Please try again.</span><button type="button" class="plx-rm__link" data-plx-rm>Remove</button>';
      });
  });

  // the pop-up
  function loadAddProducts(cb) {
    if (addState.products) { cb(addState.products); return; }
    var cid = contractId();
    fetch(apiUrl('data/products1?cursor=null&next=true&search=&contractId=' + cid + '&productSelectionOption=ALL_PRODUCTS&purchaseOption=SUBSCRIBE&sellingPlanIds='), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (j) {
        var handles = Object.keys((j && j.productHandleData) || {}).map(function (k) { return j.productHandleData[k]; });
        return Promise.all(handles.map(function (h) {
          return fetch('/products/' + h + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
        }));
      })
      .then(function (list) {
        addState.products = (list || []).filter(function (p) { return p && p.variants && p.variants.some(function (v) { return v.available; }); });
        cb(addState.products);
      })
      .catch(function () { cb([]); });
  }
  var SUB_PCT = 15;
  var STICKER = (function () {
    var sc = document.querySelector('script[src*="pluxos-portal.js"]'), base = sc ? sc.src.replace(/pluxos-portal\.js.*$/, '') : '';
    return base ? { unscented: base + 'pluxos-scent-unscented.png', peach: base + 'pluxos-scent-peach.png', vanilla: base + 'pluxos-scent-vanilla.png' } : {};
  })();
  function subPrice(c) { return Math.round(c * (100 - SUB_PCT) / 100); }
  function img(src, w) { if (!src) return ''; src = String(src); if (src.indexOf('//') === 0) src = 'https:' + src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200); }
  function nameParts(t) { var p = String(t || '').split('|'); return { name: p[0].trim(), desc: p.slice(1).join('|').trim() }; }
  var addPop = null;
  function closeAdd() {
    if (!addPop) return;
    addPop.remove(); addPop = null;
    document.documentElement.classList.remove('plx-addm-open');
  }
  function openAdd(btn) {
    closeAdd();
    var p = (btn.getAttribute('data-plx-add') || '').split('-');
    var day = new Date(+p[0], +p[1] - 1, +p[2]);
    var isNext = btn.getAttribute('data-plx-next') === '1';
    // products added to the subscription start with the next delivery, whichever card they were added from
    var firstDay = nextBillingDay() || day;
    var st = { product: null, variant: null, qty: 1, mode: isNext ? 'onetime' : 'sub', busy: false };
    addPop = document.createElement('div');
    addPop.className = 'plx-addm';
    addPop.innerHTML = '<div class="plx-addm__card" role="dialog" aria-modal="true" aria-labelledby="plxAddTitle">' +
      '<div class="plx-addm__head"><div><p class="plx-addm__eyebrow">' + (isNext ? 'Upcoming delivery' : 'Delivery') + ' · ' + esc(shortD(day)) + '</p>' +
      '<h3 class="plx-addm__title" id="plxAddTitle">Add to order</h3></div>' +
      '<button type="button" class="plx-addm__x" data-plx-add-close aria-label="Close">&times;</button></div>' +
      '<div class="plx-addm__body"><p class="plx-addm__loading">Loading products…</p></div></div>';
    document.body.appendChild(addPop);
    document.documentElement.classList.add('plx-addm-open');
    var body = addPop.querySelector('.plx-addm__body');
    addPop.addEventListener('click', function (e) {
      if (e.target === addPop || (e.target.closest && e.target.closest('[data-plx-add-close]'))) { if (!st.busy) closeAdd(); }
    });
    function list(products) {
      if (!addPop) return;
      if (!products.length) { body.innerHTML = '<p class="plx-addm__msg">Couldn\'t load products. Please try again.</p>'; return; }
      body.innerHTML = '<p class="plx-addm__lead">Pick a product to add' + (isNext ? '' : ' to your subscription') + '.</p>' +
        '<div class="plx-addm__list">' + products.map(function (pr, i) {
          var np = nameParts(pr.title), v = pr.variants[0];
          return '<button type="button" class="plx-addm__item" data-plx-pick="' + i + '">' +
            '<img src="' + esc(img(pr.featured_image, 160)) + '" alt="" width="64" height="64" loading="lazy">' +
            '<span class="plx-addm__itxt"><b>' + esc(np.name) + '</b><span>' + esc(np.desc) + '</span>' +
            '<span class="plx-addm__iprice">' + priceRow(subPrice(v.price), v.compare_at_price > v.price ? v.compare_at_price : v.price, 'plx-addm__ip') + '<em>' + (isNext ? 'when subscribed' : 'per delivery') + '</em></span></span>' +
            '<span class="plx-addm__chev" aria-hidden="true">›</span></button>';
        }).join('') + '</div>' +
        (isNext ? '' : '<p class="plx-addm__note">One-time add-ons can be added only when it is your next upcoming delivery.</p>');
      Array.prototype.forEach.call(body.querySelectorAll('[data-plx-pick]'), function (b) {
        b.addEventListener('click', function () { st.product = products[+b.getAttribute('data-plx-pick')]; st.variant = st.product.variants.filter(function (v) { return v.available; })[0]; st.qty = 1; detail(products); });
      });
    }
    // scent choice like the product page: one labelled row per option (SUN VEIL 47 SCENT, NOCTURNE SCENT…), the
    // scent-coloured options with the watercolour stickers; Skin Code Set also shows its fixed DUSK SCENT · UNSCENTED
    function scentRows(pr, v) {
      var names = (pr.options || []).map(function (o) { return typeof o === 'string' ? o : (o && o.name) || ''; });
      var vopts = function (x) { return x.options || [x.option1, x.option2, x.option3].filter(function (y) { return y != null; }); };
      if (pr.variants.length <= 1 && !/skin-code-set/.test(pr.handle || '')) return '';
      var cur = vopts(v), html = '';
      names.forEach(function (name, i) {
        var vals = [];
        pr.variants.forEach(function (x) { var o = vopts(x)[i]; if (o != null && vals.indexOf(o) < 0) vals.push(o); });
        if (vals.length < 1 || (vals.length === 1 && /^default title$/i.test(vals[0]))) return;
        html += '<p class="plx-addm__label">' + esc(names.length === 1 && /scent/i.test(name) ? 'Scent' : name) + '</p><div class="plx-addm__scents">' +
          vals.map(function (val) {
            var ok = pr.variants.some(function (x) { var o = vopts(x); return o[i] === val && x.available; });
            return scentBtn(val, cur[i] === val, ok, 'data-plx-opt="' + i + '" data-plx-val="' + esc(val) + '"');
          }).join('') + '</div>';
      });
      if (/skin-code-set/.test(pr.handle || '')) html += '<p class="plx-addm__label">Dusk Scent</p><div class="plx-addm__scents">' + scentBtn('Unscented', true, true, 'data-plx-fixed aria-disabled="true" tabindex="-1"') + '</div>';
      return html;
    }
    function scentBtn(val, on, ok, attrs) {
      var key = String(val).toLowerCase(), tint = SCENT_TINT[key] || '#F6F4EF';
      var stk = STICKER[key] ? '<img class="plx-addm__stk' + (key === 'peach' ? '' : ' plx-addm__stk--big') + '" src="' + STICKER[key] + '" alt="" aria-hidden="true">' : '';
      return '<button type="button" class="plx-addm__scent' + (on ? ' is-on' : '') + '"' + (key === 'unscented' ? ' data-white' : '') + ' style="--tint:' + tint + '" aria-pressed="' + (on ? 'true' : 'false') + '" ' + attrs + (ok ? '' : ' disabled') + '><span>' + esc(val) + '</span>' + stk + '</button>';
    }
    function detail(products) {
      var pr = st.product, np = nameParts(pr.title);
      var v = st.variant, one = v.price * st.qty, sub = subPrice(v.price) * st.qty, cmp = (v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : v.price) * st.qty;
      var opt = function (mode, label, sub1, price) {
        return '<label class="plx-addm__opt' + (st.mode === mode ? ' is-on' : '') + '"><input type="radio" name="plxAddMode" value="' + mode + '"' + (st.mode === mode ? ' checked' : '') + '>' +
          '<span class="plx-addm__otxt"><b>' + label + '</b><span>' + sub1 + '</span></span><span class="plx-addm__oprice">' + price + '</span></label>';
      };
      body.innerHTML = '<button type="button" class="plx-addm__back" data-plx-back>‹ All products</button>' +
        '<div class="plx-addm__prod"><img src="' + esc(img(pr.featured_image, 240)) + '" alt="" width="84" height="84"><div><b>' + esc(np.name) + '</b><span>' + esc(np.desc) + '</span></div></div>' +
        scentRows(pr, v) +
        '<p class="plx-addm__label">Quantity</p><div class="plx-addm__qty"><button type="button" data-plx-qty="-1" aria-label="Less"' + (st.qty <= 1 ? ' disabled' : '') + '>−</button><span>' + st.qty + '</span><button type="button" data-plx-qty="1" aria-label="More"' + (st.qty >= 10 ? ' disabled' : '') + '>+</button></div>' +
        '<p class="plx-addm__label">How often</p><div class="plx-addm__opts">' +
        (isNext ? opt('onetime', 'One-time', 'This delivery only (' + esc(shortD(day)) + ')', priceRow(one, cmp, 'plx-addm__op')) : '') +
        opt('sub', 'Add to my subscription', 'Every delivery, starting ' + esc(shortD(firstDay)) + ' · ' + SUB_PCT + '% off + your rewards', priceRow(sub, cmp, 'plx-addm__op')) +
        '</div>' +
        (isNext ? '' : '<p class="plx-addm__note">One-time add-ons can be added only when it is your next upcoming delivery.</p>') +
        '<button type="button" class="plx-addm__go" data-plx-add-go>' + (st.mode === 'onetime' ? 'Add to this delivery' : 'Add to my subscription') + '</button>' +
        '<p class="plx-addm__msg" role="status"></p>';
      body.querySelector('[data-plx-back]').addEventListener('click', function () { if (!st.busy) list(products); });
      Array.prototype.forEach.call(body.querySelectorAll('[data-plx-opt]'), function (b) {
        b.addEventListener('click', function () {
          var i = +b.getAttribute('data-plx-opt'), val = b.getAttribute('data-plx-val');
          var vo = function (x) { return x.options || [x.option1, x.option2, x.option3].filter(function (y) { return y != null; }); };
          var want = vo(st.variant).slice(); want[i] = val;
          var match = pr.variants.filter(function (x) { var o = vo(x); return want.every(function (w, j) { return o[j] === w; }) && x.available; })[0] ||
            pr.variants.filter(function (x) { return vo(x)[i] === val && x.available; })[0];
          if (match) { st.variant = match; detail(products); }
        });
      });
      Array.prototype.forEach.call(body.querySelectorAll('[data-plx-qty]'), function (b) { b.addEventListener('click', function () { st.qty = Math.max(1, Math.min(10, st.qty + +b.getAttribute('data-plx-qty'))); detail(products); }); });
      Array.prototype.forEach.call(body.querySelectorAll('input[name="plxAddMode"]'), function (r) { r.addEventListener('change', function () { st.mode = r.value; detail(products); }); });
      body.querySelector('[data-plx-add-go]').addEventListener('click', function () { go(this); });
    }
    function go(b) {
      if (st.busy) return;
      st.busy = true;
      var msg = body.querySelector('.plx-addm__msg');
      b.disabled = true; b.textContent = 'Adding…'; msg.textContent = '';
      var cid = contractId();
      var url = 'v2/subscription-contracts-add-line-item?contractId=' + cid + '&quantity=' + st.qty + '&variantId=' + encodeURIComponent('gid://shopify/ProductVariant/' + st.variant.id) + (st.mode === 'onetime' ? '&isOneTimeProduct=true' : '');
      fetch(apiUrl(url), { method: 'PUT', credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          b.textContent = 'Added';
          msg.textContent = st.mode === 'onetime' ? 'Added to your ' + shortD(day) + ' delivery. Updating…' : 'Added to your subscription, starting ' + shortD(firstDay) + '. Updating…';
          try { sessionStorage.setItem('plxAfterUnskip', JSON.stringify({ date: ymd(st.mode === 'onetime' ? day : firstDay), cid: cid, t: Date.now() })); } catch (err) {}
          setTimeout(function () { location.reload(); }, 900);
        })
        .catch(function () {
          st.busy = false; b.disabled = false; b.textContent = st.mode === 'onetime' ? 'Add to this delivery' : 'Add to my subscription';
          msg.textContent = "Couldn't add this right now. Please try again, or email help@pluxos.com and we'll add it for you.";
        });
    }
    loadAddProducts(list);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-plx-add]');
    if (!b || b.closest('.plx-addm')) return;
    e.preventDefault();
    openAdd(b);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && addPop) closeAdd(); });

  /* 16. Add-on product cards (Details tab "Add to order" upsell + Appstle's Add products pop-up), owner Oct 22:
         one tidy layout so prices line up across cards: short name (before "|") + grey description (2 lines), then
         the price row, then the scent rows, button at the bottom. Price row is ours (Appstle's is hidden): price in
         black, the product's original compare-at price in grey strikethrough, and a black savings tag vs that price
         (Add to subscription $37.40 / $52.00 → 28% OFF; One-time only $44.00 / $52.00 → 15% OFF). Compare-at prices
         come from #PlxAdCompare (account slide-out snippet), falling back to Appstle's struck price. */
  var plxCmpMap = null;
  function cmpFor(variantId) {
    if (!plxCmpMap) { try { plxCmpMap = JSON.parse((document.getElementById('PlxAdCompare') || {}).textContent || '{}'); } catch (e) { plxCmpMap = {}; } }
    return plxCmpMap[String(variantId)] || 0;
  }
  function cents(t) { var n = parseFloat(String(t || '').replace(/[^0-9.]/g, '')); return isNaN(n) ? 0 : Math.round(n * 100); }
  function pctOff(price, cmp) { return cmp > price && price > 0 ? Math.floor((cmp - price) * 100 / cmp) : 0; }
  function priceRow(price, cmp, cls) {
    var pct = pctOff(price, cmp);
    return '<span class="' + cls + '__now">' + money(price) + '</span>' +
      (pct > 0 ? '<s class="' + cls + '__was">' + money(cmp) + '</s><span class="' + cls + '__tag">' + pct + '% off</span>' : '');
  }
  function upsellCards() {
    Array.prototype.forEach.call(document.querySelectorAll('.as-product-card'), function (card) {
      var t = card.querySelector('.as-my-3 .as-product-title-tag-a');
      if (t) {
        var raw = (t.textContent || '').trim();
        if (raw && t.getAttribute('data-plx-src') !== raw) {
          var np = nameParts(raw);
          t.setAttribute('data-plx-src', raw);
          t.setAttribute('data-plx-name', np.name);
          t.setAttribute('data-plx-sub', np.desc);
        }
      }
      var foot = card.querySelector(':scope > footer');
      var pd = foot && foot.querySelector(':scope > div:first-child');
      if (!pd || pd.classList.contains('plx-uprice')) return;
      var ps = pd.querySelectorAll('p');
      if (!ps.length) return;
      var cur = cents(ps[0].textContent), was = cents((pd.querySelector('.as-compare-price') || {}).textContent);
      var cmp = Math.max(cmpFor(card.getAttribute('data-variant-id')), was);
      if (!cur) return;
      pd.setAttribute('data-plx-hide', '');
      var row = foot.querySelector(':scope > .plx-uprice');
      if (!row) { row = document.createElement('div'); row.className = 'plx-uprice'; foot.insertBefore(row, pd.nextSibling); }
      var html = priceRow(cur, cmp, 'plx-uprice');
      if (row.innerHTML !== html) row.innerHTML = html;
    });
  }

  /* 17. "Change" next to Ships to (My account subscription cards, owner Oct 22) links to
         /apps/subscriptions?plx=ship#/subscriptions/<id>/detail: once that subscription's Details page has loaded,
         open Appstle's own Edit shipping address (the EDIT on Shipping info) and bring it into view. One go only:
         the ?plx=ship flag is removed from the address straight away, and it gives up after 20 seconds. */
  var plxShip = /[?&]plx=ship\b/.test(location.search) ? Date.now() : 0;
  if (plxShip) {
    try { history.replaceState(history.state, '', location.pathname + location.search.replace(/([?&])plx=ship(&|$)/, function (m, a, b) { return b ? a : ''; }).replace(/\?$/, '') + location.hash); } catch (e) {}
  }
  function openShipEdit() {
    if (!plxShip) return;
    if (Date.now() - plxShip > 20000) { plxShip = 0; return; }
    if (!/\/subscriptions\/\d+\/detail/.test(location.hash)) return;
    var cta = Array.prototype.filter.call(document.querySelectorAll('.as-edit-shipping_cta'), function (el) { return el.offsetParent; })[0];
    if (!cta) return;
    plxShip = 0;
    cta.click();
    setTimeout(function () {
      var box = document.querySelector('.as-edit-shipping_data form, .as-cp-modal, .as-edit-shipping_data');
      (box || cta).scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 400);
  }

  /* 18. Shipping wording (owner, Oct 22): the Shipping info EDIT on Details reads CHANGE SHIPPING ADDRESS; in
         Appstle's pop-up the title reads Change shipping address, "Current Address" → "Delivers to", the address
         card's Edit → Change address. The Select Shipping Method dropdown is hidden in CSS (we only ship). */
  function shipLabels() {
    Array.prototype.forEach.call(document.querySelectorAll('.as-edit-shipping_cta'), function (el) {
      if (!el.closest('.as-cp-modal')) setText(el, 'Change shipping address');
    });
    var m = document.querySelector('.as-model-shipping-details');
    if (!m) return;
    setText(m.querySelector('.as-modal-header > span'), 'Change shipping address');
    Array.prototype.forEach.call(m.querySelectorAll('.as-modal-body h3'), function (h) {
      if (/current address/i.test(h.textContent)) setText(h, 'Delivers to');
    });
    Array.prototype.forEach.call(m.querySelectorAll('.as-modal-body button'), function (b) {
      if (/^edit$/i.test((b.textContent || '').trim())) { setText(b, 'Change address'); b.setAttribute('data-plx-shipedit', ''); }
    });
  }

  function run() {
    try { loadPrices(); } catch (e) {}
    try { skippedCards(); } catch (e) {}
    try { afterUnskip(); } catch (e) {}
    try { historyUnskip(); } catch (e) {}
    try { reactivateButtons(); } catch (e) {}
    try { numberSubs(); } catch (e) {}
    try { deliveryExtras(); } catch (e) {}
    try { addToOrder(); } catch (e) {}
    try { rewardChips(); } catch (e) {}
    try { renameTabs(); } catch (e) {}
    try { tidyLines(); } catch (e) {}
    try { subFacts(); } catch (e) {}
    try { historyCards(); } catch (e) {}
    try { compactProducts(); } catch (e) {}
    try { rewriteLadder(); } catch (e) {}
    try { rewriteLadderModal(); } catch (e) {}
    try { enhanceDetails(); } catch (e) {}
    try { rewriteOffers(); } catch (e) {}
    try { scentPills(); } catch (e) {}
    try { upsellCards(); } catch (e) {}
    try { openShipEdit(); } catch (e) {}
    try { shipLabels(); } catch (e) {}
  }
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    // next frame, with a timer as backup (frames pause in background tabs, which used to stall all updates)
    var ran = false;
    var go = function () { if (ran) return; ran = true; queued = false; run(); };
    requestAnimationFrame(go);
    setTimeout(go, 150);
  }
  function start() {
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
